module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_07-3644d1a680ff1c177d0fea7e33e449f6.png";